import React from 'react';

import { SearchProvider } from '@atlas/core';

import SearchListContainer from './SearchListContainer';
import Input from './StandardInput';

const Search = () => {
  return (
    <SearchProvider>
      <div>
        <Input />
        <SearchListContainer />
      </div>
    </SearchProvider>
  );
};

export default Search;
